import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { useDebounce } from '@uidotdev/usehooks'

import { useUserToken } from '@/features/user-token-provider/use-user-token'

import { QueryKeys } from '@/app/_utils/react-query'

import fetchSearchResult from './fetch-search-results'

import { MIN_ACCEPTABLE_QUERY_LENGTH } from '../constants'

export function useSearchResults(query: string, enabled: boolean) {
    const { userToken } = useUserToken()
    const debouncedQuery = useDebounce(query, 300)

    const isQueryLengthAcceptable = debouncedQuery.length === 0 || debouncedQuery.length > MIN_ACCEPTABLE_QUERY_LENGTH

    const {
        isLoading,
        isError,
        data: response,
        isFetching,
    } = useQuery({
        queryKey: QueryKeys.Layout.Search(userToken, debouncedQuery),
        queryFn: ({ signal }) => fetchSearchResult({ userToken, query: debouncedQuery, signal }),
        enabled: enabled && isQueryLengthAcceptable && !!userToken,
        placeholderData: keepPreviousData,
        refetchOnMount: false,
    })

    const results = response?.isSuccess ? response.data : null
    const noResult =
        !results?.brands?.length &&
        !results?.categories?.length &&
        !results?.products?.length &&
        !(isFetching && isLoading)

    return {
        results,
        noResult,
        isFetching,
        isLoading,
        isError,
        debouncedQuery,
    }
}
